<template>
  <div class="app-container">
    <div class="header">
      <div class="header-search">
        <el-form :inline="true">
          <el-form-item label="">
            <el-input
              v-model="searchParams.searchKey"
              placeholder="搜索政策名称/部门名称"
              @keyup.enter.native="getSearch"
              clearable
              @clear="getSearch"
            >
              <i
                @click="getSearch"
                slot="suffix"
                class="el-input__icon el-icon-search"
              ></i
            ></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-select
              v-model="searchParams.areaName"
              placeholder="行政区划"
              @change="getSearch"
              clearable
            >
              <el-option
                v-for="item in areaList"
                :key="item.county"
                :label="item.county"
                :value="item.county"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-button type="small" @click="dialogImport = true">导入</el-button>
      </div>
    </div>
    <el-table
      :data="listData"
      style="width: 100%"
      :header-cell-style="{ background: '#fafafa' }"
      height="500"
    >
      <el-table-column label="政策名称" width="200" align="center">
        <template slot-scope="scope">
          <el-tooltip
            placement="top"
            trigger="hover"
            effect="dark"
            :content="scope.row.policyName"
          >
            <div class="overflow2">
              {{ scope.row.policyName }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        label="部门名称"
        width="200"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tooltip
            placement="top"
            trigger="hover"
            effect="dark"
            :content="scope.row.depName"
          >
            <div class="overflow2">
              {{ scope.row.depName }}
            </div>
          </el-tooltip>
          <div v-if="!scope.row.depName">-</div>
        </template>
      </el-table-column>
      <el-table-column
        label="行政区划"
        width="200"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.areaName || '-' }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="申报开始时间"
        width="200"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div>
            {{ formatTime(scope.row.startTime) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="申报结束时间">
        <template slot-scope="scope">
          <div>
            {{ formatTime(scope.row.endTime) }}
          </div>
        </template></el-table-column
      >
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="matchSettings(scope.row)">
            精准匹配</el-button
          >
          <el-button type="text" @click="viewOperate(scope.row.id)">
            查看</el-button
          >
          <el-button type="text" @click="edit(scope.row.id)"> 编辑</el-button>
          <el-button type="text" @click="deletePolicy(scope.row.id)">
            删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="table-page">
      <el-pagination
        background
        layout="total,prev, pager, next, sizes, jumper"
        :current-page.sync="searchParams.pageNum"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="searchParams.pageSize"
        :total="totalRecord"
      >
      </el-pagination>
    </div>

    <el-dialog
      title="政策详情"
      :visible.sync="detailDialogVisible"
      width="44%"
      :before-close="handleClose"
    >
      <div class="policyDetail">
        <div class="policyInfo">
          <div class="left">
            <div class="title">{{ policyDetail.policyName }}</div>
            <div class="otherInfo">
              <div>发文部门：{{ policyDetail.depName }}</div>
              <span>|</span>
              <div>
                申报时间：{{ formatTime(policyDetail.startTime) }}~
                {{ formatTime(policyDetail.endTime) }}
              </div>
            </div>
          </div>
          <div class="right">
            <img src="@/assets/images/Bitmap.png" alt="" />
          </div>
        </div>

        <div class="content">
          <div class="contentTitle">事项名称</div>
          <div class="contentDetails">
            {{ policyDetail.content || '-' }}
          </div>
          <div class="contentTitle">附件下载</div>
          <div class="contentDetails">
            <template
              v-if="
                policyDetail.policyFileUrlList &&
                policyDetail.policyFileUrlList.length
              "
            >
              <div
                v-for="(item, index) in policyDetail.policyFileUrlList"
                :key="index"
                @click="downloadFile(item)"
              >
                {{ item.fileName }}
              </div>
            </template>

            <span v-else>暂无数据</span>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleClose()">确 定</el-button>
      </span>
    </el-dialog>

    <el-drawer
      title="匹配设置"
      :visible.sync="settingDrawerVisible"
      direction="rtl"
      :before-close="handleCloseDrawer"
      size="32%"
    >
      <div class="matchSetting">
        <div class="content">
          <div class="title">
            <div class="info">
              <div>标签选择</div>
              <div>
                请选择相关关键词，我们将匹配出适合该政策的企业。完善企业信息有利于精准匹配
              </div>
            </div>
            <rotate-icon></rotate-icon>
          </div>
          <div class="select">
            <div class="select-item">
              <div class="title-item">适合区域</div>
              <div>
                <el-select
                  v-model="areaSelectItem"
                  multiple
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in areaList"
                    :key="item.county"
                    :label="item.county"
                    :value="item.county"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="select-item">
              <div class="title-item">适合标签</div>
              <div>
                <el-cascader
                  placeholder="企业标签"
                  v-model="entLabel"
                  :options="labelList"
                  @change="changeEntLabel"
                  :props="{
                    expandTrigger: 'hover',
                    label: 'name',
                    value: 'id',
                    children: 'children',
                    multiple: true,
                    checkStrictly: true,
                    emitPath: false
                  }"
                  filterable
                  :multiline="false"
                  clearable
                  :show-all-levels="false"
                >
                </el-cascader>
              </div>
            </div>
          </div>
        </div>
        <div class="drawer-footer">
          <el-button @click="settingDrawerVisible = false">取 消</el-button>
          <el-button type="primary" @click="next('nextStep')">下一步</el-button>
        </div>
      </div>
    </el-drawer>

    <el-drawer
      title="匹配设置"
      :visible.sync="successDrawerVisible"
      direction="rtl"
      :before-close="next"
      size="42%"
    >
      <div class="matchSetting">
        <matchSetting
          :id="policyId"
          :policyName="policyName"
          :areaSelect="areaSelectItem.length ? areaSelectItem.join(',') : ''"
          :labelSelect="labelSelect"
        ></matchSetting>
        <div class="drawer-footer">
          <el-button @click="next('preStep')">上一步</el-button>
        </div>
      </div>
    </el-drawer>

    <importPolicy
      @closeImportDialog="closeDialogVisible"
      @updateData="getSearch"
      :dialogImport="dialogImport"
      v-if="dialogImport"
    ></importPolicy>
  </div>
</template>

<script>
import {
  getPolicyDataByPage,
  getPolicyData,
  deletePolicyById,
  getAllDictLabel
} from '@api/yardPolicy/policyManagement/index'
import { getArea } from '@api/common'
import rotateIcon from './component/rotateIcon'
import matchSetting from './component/matchSetting'
import importPolicy from './component/importPolicy'
export default {
  name: 'ManagementList',
  components: { rotateIcon, matchSetting, importPolicy },
  data() {
    return {
      searchParams: {
        areaName: '',
        searchKey: '',
        pageNum: 1,
        pageSize: 10
      },
      areaList: [],
      listData: [],
      totalRecord: 0,
      detailDialogVisible: false, // 查看政策弹框
      settingDrawerVisible: false, // 设置弹框
      successDrawerVisible: false, // 匹配成功
      dialogImport: false, // 导入弹框
      tagOptions: [], // 标签列表
      areaOptions: [], // 区域列表
      tagSelectItem: '', // 区域项
      areaSelectItem: [], // 标签项
      policyDetail: {},
      entLabel: [],
      labelList: [],
      entListData: [], // 企业列表
      policyId: '', // 政策id
      policyName: '', // 政策名称
      labelSelect: ''
    }
  },
  mounted() {
    this.getSearch()
    this.getAreaList()
  },
  methods: {
    // 时间处理
    formatTime(val) {
      return val ? val.slice(0, 10) : '-'
    },
    getAreaList() {
      getArea().then((res) => {
        if (res.data.code === '0000') {
          this.areaList = res.data.data
        }
      })
    },
    getSearch() {
      const params = {
        ...this.searchParams
      }
      getPolicyDataByPage(params).then((res) => {
        const { code, data, msg } = res.data
        if (code == '0000') {
          this.listData = data.results
          this.totalRecord = data.totalRecord
        }
      })
    },
    handleSizeChange(val) {
      this.searchParams.pageSize = val
      this.getSearch()
    },
    handleCurrentChange(val) {
      this.searchParams.pageNum = val
      this.getSearch()
    },
    // 政策操作
    viewOperate(id) {
      getPolicyData({ id }).then((res) => {
        const { code, data, msg } = res.data
        if (res.data.code == '0000') {
          this.policyDetail = data
          this.detailDialogVisible = true
        } else {
          this.$message.error(msg)
        }
      })
    },
    // 关闭查看政策详情
    handleClose() {
      this.detailDialogVisible = !this.detailDialogVisible
    },
    // 精准匹配
    matchSettings(data) {
      this.policyId = data.id
      this.policyName = data.policyName
      this.areaSelectItem = data.areaNameStr ? data.areaNameStr.split(',') : ''
      getAllDictLabel().then((res) => {
        if (res.data.code == '0000') {
          this.labelList = res.data.data
          this.settingDrawerVisible = true
          this.labelSelect = data.lableNameStr
          this.entLabel = data.lableNameStr ? data.lableNameStr.split(',') : ''
        }
      })
    },
    // 关闭精准匹配
    handleCloseDrawer() {
      this.settingDrawerVisible = false
    },
    next(type) {
      if (type == 'nextStep') {
        if (!this.areaSelectItem.length && !this.entLabel.length) {
          return this.$message.warning('请至少选择一个匹配项')
        }
        this.successDrawerVisible = true
      } else {
        this.settingDrawerVisible = true
        this.successDrawerVisible = false
      }
    },
    // 标签、区域选择关闭
    handleCloseTag() {},
    // 删除政策
    deletePolicy(id) {
      this.$confirm('此操作将永久删除该政策, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deletePolicyById({ id }).then((res) => {
            if (res.data.code == '0000') {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getSearch()
            } else {
              this.$message.error(res.data.msg)
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 编辑政策
    edit(id) {
      this.$router.push({
        name: 'editPolicy',
        query: {
          id
        }
      })
    },
    // 导入关闭弹框回调
    closeDialogVisible(val) {
      this.dialogImport = val
    },
    // 附件下载
    downloadFile(data) {
      window.open(data.ossUrl)
    },
    changeEntLabel(data) {
      /* const values =
        this.entLabel.length > 0
          ? this.entLabel.reduce((prev, next) => prev.concat(next))
          : ''
      const dataList = [...new Set(values)] // 去重 */
      this.labelSelect = data.join(',')
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin commonStyle {
  padding-bottom: 20px;
  border-bottom: 1px dashed #eee;
}
.overflow2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.app-container {
  .header {
    display: flex;
    justify-content: space-between;
  }
  .table-page {
    width: 100%;
    text-align: center;
    margin-top: 24px;
    margin-bottom: 20px;
  }
  /deep/.el-dialog__body {
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    padding: 20px !important;
    height: 450px;
    overflow-y: auto;
  }
  /deep/.el-dialog__title {
    font-size: 16px;
  }
  /deep/.el-drawer__header {
    font-size: 16px;
    font-weight: 700;
    border-bottom: 1px solid #eee;
    color: #000;
    padding: 15px;
    margin: initial;
    & > :first-child {
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
    }
  }
  .policyDetail {
    letter-spacing: 1px;
    .policyInfo {
      @include commonStyle;
      display: flex;
      .left {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .title {
          font-size: 20px;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.85);
        }
      }
      .right {
        width: 127px;
        height: 88px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .otherInfo {
      display: flex;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
      span {
        display: inline-block;
        margin: 0 10px;
        color: rgba(194, 194, 194, 1);
        line-height: 15px;
      }
    }
    .content {
      margin-top: 12px;
      .contentTitle {
        color: #ccc;
        position: relative;
        padding-left: 10px;
        color: rgba(0, 0, 0, 0.75);
        font-size: 16px;
        font-weight: bold;
        &::before {
          content: '';
          position: absolute;
          left: 0;
          width: 4px;
          height: 16px;
          background-color: rgba(0, 119, 255, 1);
        }
      }
      .contentDetails {
        margin: 10px 0;
        line-height: 150%;
        color: rgba(0, 0, 0, 0.75);
        font-size: 14px;
        div {
          cursor: pointer;
          margin-bottom: 10px;
          color: rgba(24, 144, 255, 0.8);
        }
      }
    }
  }
  .matchSetting {
    padding: 16px 16px 0;
    height: 100%;
    .content {
      height: calc(100% - 80px);
      .title {
        padding: 20px 16px 10px;
        border-radius: 5px;
        background: linear-gradient(90deg, #d6e5ff, #eaf1ff);
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;
        .info {
          display: flex;
          flex-direction: column;
          height: 100%;
          font-weight: 700;
          div:first-child {
            width: 120px;
            height: 30px;
            display: flex;
            align-items: center;
            background: url('~@/assets/images/titleBg.png') no-repeat;
            background-size: 100% 100%;
            color: #fff;
            padding-left: 8px;
            margin-bottom: 10px;
          }
          div:nth-child(2) {
            font-size: 12px;
          }
        }
      }
      .select {
        &-item {
          margin-bottom: 24px;
          .title-item {
            opacity: 0.85;
            color: rgba(0, 0, 0, 1);
            font-size: 14px;
          }
        }
        /deep/.el-select,
        /deep/.el-cascader {
          width: 100%;
          margin: 8px 0;
        }
      }
      .list {
        /deep/.el-tag {
          margin-right: 8px;
        }
      }
    }
    .drawer-footer {
      border-top: 1px solid #ebeef5;
      padding: 10px 0;
      position: relative;
      bottom: 0;
      width: 100%;
      text-align: right;
    }
  }
}
</style>
